import { Form } from "../../components"

export const DashboardNewProduct = () => {
    return (
        <>
        <div>
            <Form title={''} />
        </div>
        
        </>
    )
}